
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M256 928.2h-62.5c-52.9 0-96-43.1-96-96V482.1c0-52.9 43.1-96 96-96H256c52.9 0 96 43.1 96 96v350.1c0 53-43.1 96-96 96zm-62.5-478.1c-17.6 0-32 14.4-32 32v350.1c0 17.6 14.4 32 32 32H256c17.6 0 32-14.4 32-32V482.1c0-17.6-14.4-32-32-32h-62.5zm348.7 478.1h-62.5c-52.9 0-96-43.1-96-96V191.8c0-52.9 43.1-96 96-96h62.5c52.9 0 96 43.1 96 96v640.5c0 52.9-43 95.9-96 95.9zm-62.4-768.4c-17.6 0-32 14.4-32 32v640.5c0 17.6 14.4 32 32 32h62.5c17.6 0 32-14.4 32-32V191.8c0-17.6-14.4-32-32-32h-62.5zm350.7 768.4H768c-52.9 0-96-43.1-96-96v-479c0-52.9 43.1-96 96-96h62.5c52.9 0 96 43.1 96 96v479c0 53-43.1 96-96 96zM768 321.3c-17.6 0-32 14.4-32 32v479c0 17.6 14.4 32 32 32h62.5c17.6 0 32-14.4 32-32v-479c0-17.6-14.4-32-32-32H768z","fill":"#fff"}})])
          )
        }
      }
    